import React from 'react';
import { AlertCircle, CheckCircle, Info } from 'lucide-react';

export type MessageType = 'warning' | 'error' | 'success' | 'info';

interface MessageProps {
  type: MessageType;
  message: string;
}

const colorClasses: Record<MessageType, string> = {
  warning: 'text-warning-messaging border-warning-messaging',
  error: 'text-error-messaging border-error-messaging',
  success: 'text-success-messaging border-success-messaging',
  info: 'text-info-messaging border-info-messaging',
};

function WarningIcon(): React.JSX.Element {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="shrink-0"
    >
      <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="2" fill="none"/>
      <path d="M16 9v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="16" cy="22" r="1.5" fill="currentColor"/>
    </svg>
  );
}

function getIcon(type: MessageType): React.JSX.Element {
  switch (type) {
  case 'warning':
    return <WarningIcon />;
  case 'error':
    return <AlertCircle size={32} strokeWidth={1.5} className="shrink-0" />;
  case 'success':
    return <CheckCircle size={32} strokeWidth={1.5} className="shrink-0" />;
  case 'info':
    return <Info size={32} strokeWidth={1.5} className="shrink-0" />;
  }
}

export function Message({ type, message }: MessageProps): React.JSX.Element {
  const colorClass = colorClasses[type];

  return (
    <div className={`warning-message !justify-start shadow-elevation-sm border ${colorClass}`}>
      <span className={colorClass.split(' ')[0]}>
        {getIcon(type)}
      </span>
      <span className="mr-2">{message}</span>
    </div>
  );
}
